import { downloadBlob } from '@sequencehq/utils'
import { useNotifications } from '@sequencehq/core-components'
import { useCallback } from 'react'
import type { ApiResponse } from '@sequencehq/api'

type UseCsvExport = (props: {
  getExport: (queryParams: URLSearchParams) => ApiResponse<Blob>
  fileName: string
}) => {
  download: {
    available: boolean
    disabled: boolean
    onClick: (queryParams: URLSearchParams) => void
  }
}

export const useCsvExport: UseCsvExport = ({ getExport, fileName }) => {
  const { displayPromiseNotification } = useNotifications()

  const downloadCsv = useCallback(
    async (queryParams: URLSearchParams) => {
      const downloadOperation = async () => {
        const response = await getExport(queryParams)

        if (response.data !== null) {
          downloadBlob(fileName)(
            new Blob([response.data], { type: 'text/csv' })
          )
          return response.data
        } else {
          throw new Error('No data received from export')
        }
      }

      await displayPromiseNotification(downloadOperation(), {
        loading: 'Preparing download',
        success: 'Download ready',
        error: 'CSV download failed'
      })
    },
    [displayPromiseNotification, getExport, fileName]
  )

  return {
    download: {
      available: true,
      disabled: false,
      onClick: queryParams => void downloadCsv(queryParams)
    }
  }
}
